import { useLang } from "@/context/LangContext";
import { Eyebrow, FadeUp } from "@/components/Reveal";
import { Markdown } from "@/components/Markdown";
import { GENERAL_TERMS_EN } from "@/data/generalTerms";
import { GENERAL_TERMS_ES } from "@/data/generalTermsEs";

export default function SimplePage({ page }) {
  const { t, lang } = useLang();
  const content = t(`legal.${page}`) || t("legal.about");
  const es = lang === "es";

  return (
    <div data-testid={`page-${page}`} className="bg-paper pt-28 md:pt-36">
      <div className="mx-auto max-w-3xl px-5 pb-24 md:pb-32">
        <FadeUp><Eyebrow>{content.eyebrow}</Eyebrow></FadeUp>
        <FadeUp delay={0.1}>
          <h1 className="mt-8 text-4xl font-semibold leading-[1.05] tracking-tight text-ink md:text-6xl">
            {content.title}
          </h1>
        </FadeUp>
        {content.updated && (
          <FadeUp delay={0.15}>
            <p className="mt-6 text-[11px] font-medium uppercase tracking-[0.25em] text-ink/40">{content.updated}</p>
          </FadeUp>
        )}

        {content.markdown ? (
          <FadeUp delay={0.2} amount={0.05}>
            <div className="mt-10">
              <Markdown text={es && GENERAL_TERMS_ES ? GENERAL_TERMS_ES : GENERAL_TERMS_EN} />
            </div>
          </FadeUp>
        ) : (
          <div className="mt-10 space-y-6">
            {content.paragraphs.map((p, i) => (
              <FadeUp key={i} delay={0.1 + i * 0.06} amount={0.4}>
                <p className="text-base leading-relaxed text-ink/70 md:text-lg">{p}</p>
              </FadeUp>
            ))}
          </div>
        )}

        {content.facts && (
          <FadeUp delay={0.2} amount={0.2}>
            <div data-testid="company-facts" className="mt-16 border border-ink/10 bg-white p-7 md:p-9">
              <h2 className="text-[11px] font-medium uppercase tracking-[0.25em] text-ink/40">{content.factsTitle}</h2>
              <dl className="mt-5">
                {content.facts.map(([k, v]) => (
                  <div key={k} className="flex flex-col gap-1 border-t border-ink/5 py-4 text-sm sm:flex-row sm:justify-between sm:gap-6">
                    <dt className="shrink-0 text-ink/50">{k}</dt>
                    <dd className="whitespace-pre-line text-ink sm:text-right">{v}</dd>
                  </div>
                ))}
              </dl>
            </div>
          </FadeUp>
        )}

        {content.quote && (
          <FadeUp delay={0.25} amount={0.3}>
            <blockquote className="mt-16 border-l-2 border-cobalt pl-6 text-xl italic leading-snug tracking-tight text-ink md:text-2xl">
              {content.quote}
            </blockquote>
          </FadeUp>
        )}
      </div>
    </div>
  );
}
